import type { Plans } from "../../components/PricingAndCheckout/types";
import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

export default {
    StartCheckout: ({ plan }: { plan: string }) =>
        fetch(`${PURCHASER_API_BASE_URL}/billing/start-checkout`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify({ plan }),
        }).then(res => res.json()),
    GetPlanDetails: () =>
        fetch(`${PURCHASER_API_BASE_URL}/billing/plan-details`, {
            method: "GET",
            headers: getHeaders(),
        }).then(res => res.json()),
    GetInvoiceHistory: () =>
        fetch(`${PURCHASER_API_BASE_URL}/billing/history`, {
            method: "GET",
            headers: getHeaders(),
        }).then(res => res.json()),
    GetBillingSettings: () =>
        fetch(`${PURCHASER_API_BASE_URL}/billing/settings`, {
            method: "GET",
            headers: getHeaders(),
        }).then(res => res.json()),
    GetInvoiceReceiptURL: (invoiceId: string) =>
        fetch(`${PURCHASER_API_BASE_URL}/billing/invoice-receipt/${invoiceId}`, {
            method: "GET",
            headers: getHeaders(),
        }).then(res => res.json()),
    DowngradePlan: (selectedPlan: Plans) =>
        fetch(`${PURCHASER_API_BASE_URL}/billing/downgrade`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify({ plan: selectedPlan }),
        }).then(res => res.json()),
};
